import { join, parse, sep } from 'node:path';
import { platform } from 'node:os';
import { getDashboardPagesDir } from '@wix/cli-app-definitions';
import { relativeFolderName } from '@wix/cli-fs';

export function replaceExtension(filePath: string, extension: string) {
  const { dir, name } = parse(filePath);
  if (extension !== '') {
    return join(dir, `${name}.${extension}`);
  }
  return join(dir, name);
}

export function deriveRoute(projectFolder: string, pagePath: string) {
  const relativeDir = relativeFolderName(
    getDashboardPagesDir(projectFolder),
    pagePath
  );

  // Replacing with `/` for Dev Center's `routePath` URL delimiter
  return `/${relativeDir.split(sep).map(encodeURIComponent).join('/')}`;
}

// Replacing backslashes with forward slashes to make globby work on Windows
// (https://github.com/sindresorhus/globby/issues/179#issuecomment-990398774)
export function normalizeGlobbyPattern(globPattern: string) {
  if (platform() === 'win32') {
    return globPattern.replaceAll('\\', '/');
  }
  return globPattern;
}
